import React from 'react';

import { useNavigate } from 'react-router';

/** images */
import congratulationImg from '../assets/images/congrats.png';
import Layout from '../components/common/Layout';

const Accepted = () => {
  const navigate = useNavigate();

  const renderLoanAccepted = () => {
    return (
      <div className="page-inner">
        <img src={congratulationImg} alt="" className="congratulations" />
        <h2>Congrats on Your New Loan!</h2>
        <div className="main-message">
          <p>You can view all future loan updates on your account dashboard.</p>
        </div>
        <button className="primary-btn" onClick={() => navigate('/dashboard')}>
          Go to Dashboard
        </button>
      </div>
    );
  };

  return (
    <Layout>
      <div className="approved-page">{renderLoanAccepted()}</div>
    </Layout>
  );
};

export default Accepted;
